/* Boost Blenz Books — ebook collection + PDP JS
   - Q&A accordion (one-open-at-a-time)
   - Newsletter form (Klaviyo client subscriptions or Shopify customer signup)
   - PDP gallery thumb switching
   - PDP format selector — update ATC price label on variant change */
(function () {
  // ───── PDP gallery (thumbs swap main cover image) ─────
  document.querySelectorAll('[data-bb-ebook-gallery]').forEach(function (gallery) {
    var mainBook = gallery.querySelector('[data-bb-ebook-view="cover"] img');
    if (!mainBook) return;
    var originalSrc = mainBook.getAttribute('src');
    // Clear srcset on swap — browsers prefer srcset over src, so the swap
    // would silently no-op otherwise.
    gallery.querySelectorAll('[data-bb-ebook-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gallery.querySelectorAll('[data-bb-ebook-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var src = btn.getAttribute('data-img-src') || originalSrc;
        mainBook.removeAttribute('srcset');
        mainBook.removeAttribute('sizes');
        mainBook.setAttribute('src', src);
      });
    });
  });

  // ───── Lightbox for look-inside images (click to zoom full-screen) ─────
  (function () {
    var trigger = document.querySelector('[data-bb-ebook-lookinside]');
    if (!trigger) {
      // Fallback: bind to all look-inside images on the page
      document.querySelectorAll('.bb-ebook-page-spread img').forEach(function (img) {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function () { openLightbox(img.src, img.alt); });
      });
      return;
    }
  })();
  function openLightbox(src, alt) {
    var overlay = document.createElement('div');
    overlay.className = 'bb-ebook-lightbox';
    overlay.innerHTML = '<button type="button" class="bb-ebook-lightbox-close" aria-label="Close">&times;</button>' +
      '<img src="' + src + '" alt="' + (alt || '') + '">';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('bb-ebook-lightbox-close')) {
        document.body.removeChild(overlay);
        document.documentElement.style.overflow = '';
      }
    });
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', function escClose(e) {
      if (e.key === 'Escape' && document.body.contains(overlay)) {
        document.body.removeChild(overlay);
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', escClose);
      }
    });
  }

  // ───── PDP format selector — keep ATC price + main gallery image in sync ─────
  document.querySelectorAll('[data-bb-ebook-buyform]').forEach(function (form) {
    var priceLabel = form.querySelector('[data-bb-ebook-cta-price]');
    // Find the gallery main image at section level (not just inside the form).
    var section = form.closest('[data-section-type="bb-ebook-product-hero"]');
    var mainImg = section ? section.querySelector('[data-bb-ebook-view="cover"] img') : null;
    form.querySelectorAll('input[type="radio"][name="id"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var opt = radio.closest('.bb-ebook-format-opt');
        if (!opt) return;
        // Sync ATC price label
        var right = opt.querySelector('.bb-ebook-fo-right');
        if (priceLabel && right && !right.classList.contains('is-soon')) {
          priceLabel.textContent = right.textContent.trim();
        }
        // Sync main gallery image to selected variant's image
        var variantImg = opt.getAttribute('data-variant-image');
        if (mainImg && variantImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.setAttribute('src', variantImg);
        }
      });
    });
  });

  // ───── One copy per eBook ─────
  //
  // An eBook is a download the customer can open any time, so a second copy
  // buys them nothing and risks FileFlare sending the same file twice. Physical
  // products are unaffected — buy a hundred jars if you like.
  //
  // The check is per PRODUCT, not per variant: two covers of the same book are
  // the same book. It runs before the add, so the duplicate line never exists,
  // rather than relying on the cart drawer's sweep to tidy it up afterwards
  // (which it does, but the customer sees two lines in the meantime).
  var DUPE_DEFAULTS = {
    paid: 'This eBook is already in your cart — one copy is all you need.',
    free: "You're already getting this eBook free with something else in your cart."
  };

  function findExistingEbookLine(cart, productId) {
    return (cart.items || []).find(function (it) { return it.product_id === productId; });
  }

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  // Where the notice goes: DIRECTLY under the Add to Cart button, so it lands in
  // the spot the customer is already looking at after clicking.
  //   • PDP — the buy actions stack vertically, so it slots in right beneath the
  //     ATC button, above the secondary button.
  //   • Collection hero — the CTAs sit in a ROW, so it goes under the whole row
  //     instead; inside the row it would be squeezed into one narrow column.
  function noticeAnchor(form) {
    var heroRow = form.closest('.bb-ebook-hero-cta');
    if (heroRow && heroRow.parentNode) {
      return { parent: heroRow.parentNode, before: heroRow.nextSibling };
    }
    var btn = form.querySelector('button[type="submit"]');
    if (btn && btn.parentNode) return { parent: btn.parentNode, before: btn.nextSibling };
    return { parent: form.parentNode, before: null };
  }

  // Self-dismissing confirmation. role=status + aria-live so screen readers hear
  // it too — otherwise the click would appear to do nothing at all.
  function showEbookNotice(form, message) {
    var anchor = noticeAnchor(form);
    var note = anchor.parent.querySelector(':scope > [data-bb-ebook-notice]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'bb-ebook-notice';
      note.setAttribute('data-bb-ebook-notice', '');
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      var icon = document.createElement('span');
      icon.className = 'bb-ebook-notice-icon';
      icon.innerHTML = CHECK_SVG;           // static markup, not user content
      var text = document.createElement('span');
      text.className = 'bb-ebook-notice-text';
      note.appendChild(icon);
      note.appendChild(text);
      anchor.parent.insertBefore(note, anchor.before);
    }
    // textContent, never innerHTML — the message is merchant-editable copy.
    note.querySelector('.bb-ebook-notice-text').textContent = message;
    note.classList.remove('is-visible');
    void note.offsetWidth;                 // restart the fade
    note.classList.add('is-visible');
    clearTimeout(note._hideTimer);
    note._hideTimer = setTimeout(function () { note.classList.remove('is-visible'); }, 5000);
  }

  // Gift variant ids the form was rendered with (from bb-cro-gift-ids.liquid,
  // the SAME metafields that render the bonus card — so the card and the cart
  // payload can never disagree). Malformed/empty ⇒ no gifts ⇒ plain add.
  function parseGifts(form) {
    var raw = form.getAttribute('data-gifts');
    if (!raw) return [];
    try {
      var list = JSON.parse(raw);
      return Array.isArray(list) ? list.filter(function (n) {
        return typeof n === 'number' && n > 0;
      }) : [];
    } catch (e) { return []; }
  }

  // ───── AJAX add-to-cart for every ebook buy form ─────
  //
  // The buy forms (PDP hero, collection hero, library grid cards) keep their
  // native method="post" action="/cart/add" so they still work if this JS fails
  // (progressive enhancement). With JS we intercept the submit so the page NEVER
  // navigates to the white "Adding to cart…" screen: we POST /cart/add.js and
  // dispatch the same cart:added + bb:cart:open events the PDP/homepage use, so
  // the shared cart drawer slides open in place.
  //
  // TWO PATHS, chosen per form by data-gifts:
  //   • no gifts → plain single-line /cart/add.js, exactly as before.
  //   • gifts    → window.BBCart.addBundle, the SAME call the detox PDPs and
  //     the homepage quick-add use. That is what makes an ebook's free bonus
  //     behave identically to the Parasite eBook on a detox PDP: the bonus goes
  //     in tagged _bb_gift_for, the parent records it in _bb_gifts, gifts stay
  //     cart-level singletons, the bonus is swept out when its trigger leaves,
  //     and a paid copy already in the cart is KEPT (the gift duplicate is
  //     dropped) so it flips to free while the trigger is present and reverts
  //     to its price when the trigger goes. None of that is new code — it is
  //     the existing cart-drawer bookkeeping, which this path opts into.
  //
  // Falls back to the plain path if bb-cart-add.js didn't load, so a missing
  // script costs the bonus line, never the sale.
  document.querySelectorAll('[data-bb-ebook-buyform]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idField = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]');
      if (!idField || !idField.value) return;
      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      if (btn) {
        btn.dataset.orig = btn.innerHTML;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        btn.innerHTML = 'Adding…';
      }
      var variantId = parseInt(idField.value, 10);
      var gifts = parseGifts(form);
      var useBundle = gifts.length > 0 && window.BBCart && typeof window.BBCart.addBundle === 'function';

      var restore = function () {
        if (btn) {
          btn.removeAttribute('aria-busy');
          btn.disabled = false;
          btn.innerHTML = btn.dataset.orig;
        }
      };

      // One-copy guard for digital products. `data-single-copy` is rendered
      // from the variant's requires_shipping, so physical products never take
      // this path even if they use the same form.
      var singleCopy = form.getAttribute('data-single-copy') === 'true';
      var productId = parseInt(form.getAttribute('data-product-id'), 10);
      if (singleCopy && productId) {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var existing = findExistingEbookLine(cart, productId);
            if (!existing) return proceed();
            var isFree = existing.final_price === 0;
            showEbookNotice(form,
              (isFree ? (form.getAttribute('data-msg-free') || DUPE_DEFAULTS.free)
                      : (form.getAttribute('data-msg-paid') || DUPE_DEFAULTS.paid)));
            restore();
          })
          // A failed cart read must not block the sale — fall through and add.
          ['catch'](function () { proceed(); });
        return;
      }
      proceed();

      function proceed() {
      var request = useBundle
        ? window.BBCart.addBundle({
            variantId: variantId,
            bundleId: form.getAttribute('data-bundle-id') || String(variantId),
            giftIds: gifts,
            qty: 1
          })
        : fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then(function (r) {
              return r.json().then(function (b) {
                if (!r.ok || b.status) { throw new Error(b.description || b.message || 'Could not add to cart.'); }
                return b;
              });
            })
            .then(function () {
              // addBundle dispatches these itself — only the plain path needs them.
              document.dispatchEvent(new CustomEvent('cart:added', { detail: { silent: false } }));
              document.dispatchEvent(new CustomEvent('bb:cart:open'));
            });

      request
        .catch(function (err) {
          window.alert(err.message || 'Sorry, we could not add that to your cart.');
        })
        .then(restore);
      }
    });
  });

  // ───── Q&A accordion ─────
  document.querySelectorAll('[data-bb-ebook-qa]').forEach(function (root) {
    var items = root.querySelectorAll('[data-bb-ebook-qa-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-bb-ebook-qa-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        items.forEach(function (other) { other.setAttribute('data-open', 'false'); });
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  });

  // ───── Newsletter capture ─────
  //
  // For each per-book signup, we send TWO things to Klaviyo so campaigns + flows
  // can segment by which ebook the subscriber signed up on:
  //
  //   1. profile properties via /client/subscriptions  — `ebook_product`,
  //      `ebook_title`, `signup_source`. Survives across visits; works for
  //      segments like "anyone who signed up for food-as-a-weapon".
  //   2. event via /client/events                      — `Signed Up for Ebook`
  //      with the same properties. Best for triggering a per-book welcome flow,
  //      because each signup is a discrete event (segments only fire on profile
  //      changes; events always fire).
  //
  // If the form has data-klaviyo-list, we send to that list. If not, we fall
  // back to a Shopify customer signup tagged 'newsletter,ebook-page,<handle>'.
  document.querySelectorAll('[data-bb-ebook-capture-form]').forEach(function (form) {
    var statusEl = form.parentNode.querySelector('[data-bb-ebook-capture-status]');
    var klaviyoList = form.getAttribute('data-klaviyo-list') || '';
    var ebookHandle = form.getAttribute('data-ebook-product') || '';
    var ebookTitle = form.getAttribute('data-ebook-title') || '';
    var companyId = (klaviyoList.split(':')[0] || '').trim();
    var listId = klaviyoList.split(':').pop() || '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var email = (emailInput && emailInput.value || '').trim();
      if (!email) return;
      var btn = form.querySelector('button');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = 'Sending…'; }
      if (statusEl) statusEl.textContent = '';

      var done = function (ok, msg) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Send It'; }
        if (statusEl) statusEl.textContent = msg;
        if (ok && emailInput) emailInput.value = '';
      };

      // Per-book custom properties — same shape for subscription + event.
      var ebookProps = {
        ebook_product: ebookHandle,
        ebook_title: ebookTitle,
        signup_source: 'ebook_pdp'
      };

      if (companyId && listId) {
        // 1. Subscribe + write properties.
        //    https://developers.klaviyo.com/en/reference/create_client_subscription
        var subscribePromise = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: ebookProps
                    }
                  }
                },
                custom_source: 'Boost Blenz Books (' + (ebookHandle || 'ebook') + ')'
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        });

        // 2. Fire an event so per-book flows can trigger reliably.
        //    Events always fire, even for already-subscribed profiles.
        //    https://developers.klaviyo.com/en/reference/create_client_event
        var eventPromise = fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: ebookProps,
                metric: { data: { type: 'metric', attributes: { name: 'Signed Up for Ebook' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          })
        }).catch(function () { /* event is best-effort — don't block the user on it */ });

        subscribePromise.then(function (r) {
          if (r.ok || r.status === 202) done(true, "Thanks — check your inbox.");
          else done(false, "Hmm, that didn't work. Try again?");
        }).catch(function () { done(false, "Network hiccup. Try again?"); });
      } else {
        // Fallback: Shopify customer signup. Append the ebook handle as a tag
        // so admins can still segment by book without Klaviyo configured.
        var tags = 'newsletter,ebook-page';
        if (ebookHandle) tags += ',ebook-' + ebookHandle;
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[tags]', tags);
        fd.append('contact[email]', email);
        fetch('/contact#contact_form', { method: 'POST', body: fd })
          .then(function () { done(true, "Thanks — you're on the list."); })
          .catch(function () { done(false, "Network hiccup. Try again?"); });
      }
    });
  });
})();
